import MediumDashboardView from "src/sections/dashboards/platforms/medium/medium-dashboard-view";

const MediumCustomDashboardPage = () => <MediumDashboardView type="custom" />;

export default MediumCustomDashboardPage;
